<template>
    <div v-if="isLoaded">
        <div class="mb-4 mt-2">
            <img class="mx-auto w-auto h-25" :src="campaign.FullImageUrl" />
        </div>
        <div class="text-14 font-bold text-a-brown-502314 text-center mb-6 text-3-line" v-html="campaignName"></div>
        <div class="px-10" v-if="showBtn">
            <RedButton @click="gotoDetail()">
                {{lbl.detail.view_detail}}
            </RedButton>
        </div>
    </div>
</template>
<script>
import RedButton from '@/components/Button/RedButton.vue'
import Utility from '@/helper/Utility'
import { CampaignType } from "@/helper/StaticValue.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import BzbsCampaign from '@/core/Campaign/service/BzbsCampaign.js';
import { CampaignConfigBuilder } from '@/core/Campaign/model/CampaignConfigModel.js';

export default {
    name: 'NotificationTypeMessage',
    props: {
        campaign: {
            type: Object
        }
    },
    components: {
        RedButton
    },
    mixins: [LocaleMixin],
    emits: [],
    data: function () { return {
        campaignDetail: null,
        campaignName: null,
        showBtn: true,
        isLoaded: false,
    } },
    computed: {
        isShowIconFood: function () {
            let msg = this?.message ?? ""
            let foodRegex = /^\(food\)/
            if (foodRegex.test(msg)) {
                return true
            }
            return false
        },
    },
    created: function () {
        this.campaignName = this.campaign.CampaignName;
        this.getCampaignDetail()
    },
    mounted: function () { },
    methods: {
        clickOrderNow: function () {
            if (this.campaignDetail.type == CampaignType.Buy) {
                this.$router.push({
                    name: "product_detail",
                    params: {
                        id: this.campaign.CampaignId
                    }
                });
            } else {
                this.$router.push({
                    name: "noti_detail",
                    params: {
                        campaignId: this.campaign.CampaignId
                    }
                });
            }
        },
        gotoDetail: function () {
            this.$emit("onClose");
            this.$router.push("/notidetail/" + this.campaign.CampaignId);

        },
        getname: function (name) {
            return Utility.newLineToBr(name);
        },
        getCampaignDetail: function () {
            this.campaignConfig = new CampaignConfigBuilder()
                .setCampaignId(this.campaign.CampaignId)
                .create();

            return new Promise((resolve, reject) => {
                BzbsCampaign.apiGetCampaignDetail(this.campaignConfig).subscribe((res) => {
                    this.campaignDetail = res;
                    this.campaignName = this.campaignDetail.name;

                    if (this.campaignDetail.type == CampaignType.Voucher) {
                        this.showBtn = false;
                    } else {
                        this.showBtn = true;
                    }

                    this.isLoaded = true;
                    resolve(res);
                }, (err) => {
                    this.isLoaded = true;
                    reject(err);
                });
            });
        },
    }
}
</script>
